import React from "react";
import { TextField } from "@fluentui/react/lib/TextField";
import { Icon } from "@fluentui/react/lib/Icon";
import { DefaultButton } from "@fluentui/react/lib/Button";
import { Stack } from "@fluentui/react";
import "./customFilterTable.css";

const addIcon = { iconName: "Add" };

const getTimeinMinutes = (time) => {
  if (!(time + "").includes(":")) return 0;
  const mins = Number(time.split(":")[1]);
  const hours = Number(time.split(":")[0]);

  return hours * 60 + mins;
};

const formatMinutesToString = (minutes) => {
  let hours = Math.floor(minutes / 60);
  let mins = minutes % 60;

  if (hours < 10) {
    hours = "0" + hours;
  }

  if (mins < 10) {
    mins = "0" + mins;
  }

  return hours + ":" + mins;
};

const newData = {
  title: "Testing task timesheet",
  mon: "",
  tue: "",
  wed: "",
  thu: "",
  fri: "",
  sat: "",
  sun: "",
  total: "0",
};

const dataArray = [
  {
    id: 1,
    title: "Testing task timesheet",
    mon: "",
    tue: "",
    wed: "",
    thu: "",
    fri: "",
    sat: "",
    sun: "",
    total: "0",
  },
  {
    id: 2,
    title: "Testing task allocated time",
    mon: "8:30",
    tue: "",
    wed: "",
    thu: "",
    fri: "",
    sat: "",
    sun: "",
    total: "3:80",
  },
  {
    id: 3,
    title: "Testing task timesheet",
    mon: "",
    tue: "5:00",
    wed: "",
    thu: "",
    fri: "",
    sat: "",
    sun: "",
    total: "5:00",
  },
  {
    id: 4,
    title: "Testing task timesheet",
    mon: "",
    tue: "2:00",
    wed: "",
    thu: "",
    fri: "",
    sat: "",
    sun: "",
    total: "2:00",
  },
  {
    id: 5,
    title: "Testing task timesheet",
    mon: "",
    tue: "1:00",
    wed: "",
    thu: "",
    fri: "",
    sat: "",
    sun: "",
    total: "1:00",
  },
];

const CustomFilterTable = () => {
  const [timeSheetData, setTimeSheetData] = React.useState(dataArray);

  const addNewRow = () => {
    setTimeSheetData((prev) => [
      ...prev,
      { ...newData, id: prev?.[prev?.length - 1]?.id + 1 || 0 },
    ]);
  };

  const removeItem = (id) => {
    setTimeSheetData((prev) => prev.filter((item) => item.id !== id));
  };

  const setTaskTime = ({ id, key, value }) => {
    setTimeSheetData((prev) =>
      prev.map((item) => {
        if (item.id === id) {
          return {
            ...item,
            [key]: value,
          };
        } else {
          return { ...item };
        }
      })
    );
  };

  const getTotalTaskTime = (item) => {
    let timeInMinutes = 0;
    timeInMinutes += getTimeinMinutes(item.mon);
    timeInMinutes += getTimeinMinutes(item.tue);
    timeInMinutes += getTimeinMinutes(item.wed);
    timeInMinutes += getTimeinMinutes(item.thu);
    timeInMinutes += getTimeinMinutes(item.fri);
    timeInMinutes += getTimeinMinutes(item.sat);
    timeInMinutes += getTimeinMinutes(item.sun);

    return timeInMinutes;
  };

  let mondayTotal = 0,
    tuesdayTotal = 0,
    wednesdayTotal = 0,
    thrusdayTotal = 0,
    fridayTotal = 0,
    saturdayTotal = 0,
    sundayTotal = 0;

  timeSheetData.forEach((item) => {
    mondayTotal += getTimeinMinutes(item.mon);
    tuesdayTotal += getTimeinMinutes(item.tue);
    wednesdayTotal += getTimeinMinutes(item.wed);
    thrusdayTotal += getTimeinMinutes(item.thu);
    fridayTotal += getTimeinMinutes(item.fri);
    saturdayTotal += getTimeinMinutes(item.sat);
    sundayTotal += getTimeinMinutes(item.sun);
  });

  const totalTime =
    mondayTotal +
    tuesdayTotal +
    wednesdayTotal +
    thrusdayTotal +
    fridayTotal +
    saturdayTotal +
    sundayTotal;

  return (
    <>
      <table className="table-timesheet" id="id-table-timesheet">
        <thead>
          <tr className="table-header">
            <th className="th-title"> </th>
            <th className="th-day">M </th>
            <th className="th-day">T</th>
            <th className="th-day">W</th>
            <th className="th-day">T</th>
            <th className="th-day">F</th>
            <th className="th-day">S</th>
            <th className="th-day">Su</th>
            <th className="th-action"> </th>
          </tr>
        </thead>
        <tbody>
          {timeSheetData.length > 0
            ? timeSheetData.map((item, index) => {
                return (
                  <tr key={"DATA_ITEM-" + item.id}>
                    <td className="th-title">{item.title}</td>
                    <td className="th-day">
                      <TextField
                        className="time-input"
                        default={"data"}
                        value={item.mon}
                        onChange={(e) =>
                          setTaskTime({
                            id: item.id,
                            key: "mon",
                            value: e.target.value,
                          })
                        }
                      />
                    </td>
                    <td className="th-day">
                      <TextField
                        className="time-input"
                        default={"data"}
                        value={item.tue}
                        onChange={(e) =>
                          setTaskTime({
                            id: item.id,
                            key: "tue",
                            value: e.target.value,
                          })
                        }
                      />
                    </td>
                    <td className="th-day">
                      <TextField
                        className="time-input"
                        default={"data"}
                        value={item.wed}
                        onChange={(e) =>
                          setTaskTime({
                            id: item.id,
                            key: "wed",
                            value: e.target.value,
                          })
                        }
                      />
                    </td>
                    <td className="th-day">
                      <TextField
                        className="time-input"
                        default={"data"}
                        value={item.thu}
                        onChange={(e) =>
                          setTaskTime({
                            id: item.id,
                            key: "thu",
                            value: e.target.value,
                          })
                        }
                      />
                    </td>
                    <td className="th-day">
                      <TextField
                        className="time-input"
                        default={"data"}
                        value={item.fri}
                        onChange={(e) =>
                          setTaskTime({
                            id: item.id,
                            key: "fri",
                            value: e.target.value,
                          })
                        }
                      />
                    </td>
                    <td className="th-day">
                      <TextField
                        className="time-input"
                        default={"data"}
                        value={item.sat}
                        onChange={(e) =>
                          setTaskTime({
                            id: item.id,
                            key: "sat",
                            value: e.target.value,
                          })
                        }
                      />
                    </td>
                    <td className="th-day">
                      <TextField
                        className="time-input"
                        default={"data"}
                        value={item.sun}
                        onChange={(e) =>
                          setTaskTime({
                            id: item.id,
                            key: "sun",
                            value: e.target.value,
                          })
                        }
                      />
                    </td>
                    <td className="th-action">
                      <span style={{ marginLeft: "20px", float: "left" }}>
                        {formatMinutesToString(getTotalTaskTime(item))}
                      </span>
                      <button
                        style={{ border: "1px solid black", float: "right" }}
                        onClick={() => removeItem(item.id)}
                      >
                        <Icon iconName="StatusCircleErrorX" />
                      </button>
                    </td>
                  </tr>
                );
              })
            : "No data found"}
        </tbody>

        <tfoot className="table-footer">
          <tr>
            <th className="th-title">
              <div className="">
                <Stack horizontal>
                  <DefaultButton
                    text="New Row"
                    iconProps={addIcon}
                    onClick={() => addNewRow()}
                  />
                  <DefaultButton text="Save" disabled={true} />
                </Stack>
              </div>
            </th>
            <th className="th-day">{formatMinutesToString(mondayTotal)}</th>
            <th className="th-day">{formatMinutesToString(tuesdayTotal)}</th>
            <th className="th-day">{formatMinutesToString(wednesdayTotal)}</th>
            <th className="th-day">{formatMinutesToString(thrusdayTotal)}</th>
            <th className="th-day">{formatMinutesToString(fridayTotal)}</th>
            <th className="th-day">{formatMinutesToString(saturdayTotal)}</th>
            <th className="th-day">{formatMinutesToString(sundayTotal)}</th>
            <th className="th-action">{formatMinutesToString(totalTime)}</th>
          </tr>
        </tfoot>
      </table>
    </>
  );
};
export default CustomFilterTable;
